/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
  useLocation,
} from 'react-router-dom';
import MainContentWrapper from '../Layouts/MainContent/mainContent';
import LogIn from '../Pages/LoginPage/login';
import AxiosWrapper from '../Api/http/AxiosWrapper';
import CertificationMaster from '../Pages/CertificationMaster/certification';
import Skills from '../Pages/Skill/skills';
import CertificationCategory from '../Pages/CertificationCategory/certificationCategory';
import RoleMaster from '../Pages/RoleMaster/roleMaster';
import ClientDetails from '../Pages/ClientDetails/clientDetails';
import ZohoCustomerDetails from '../Pages/ZohoCustomerDetails/zohoCustomerDetails';
import PoDetails from '../Pages/PoDetails/poDetails';
import Targets from '../Pages/Targets/targetDashboard';
import CertifyMap from '../Pages/CertificationMap/certificationMap';
import TargetSetter from '../Pages/Targets/SetTarget/targetSetter';
import { useAuth } from '../Contexts/AuthContext';
import CertificationsOverview from '../Pages/CertificationOverview/certificationsOverviewDashboard';
import Permission from '../Pages/PermissionPage/permissionModule';
import SkillMap from '../Pages/SkillMap/skillMap';
import EmployeeProfile from '../Pages/EmployeeProfile/employeeProfile';
import Users from '../Pages/UserManagement/userManagement';
import Home from '../Pages/HomePage/home';
import MapSkills from '../Pages/SkillMap/MapSkills/mapSkills';
import ManageKpi from '../Pages/Configuration/manageKpi';
import SetKpi from '../Pages/Configuration/SetKpi/setKpi';
import Loader from '../Components/Loader';
import EditKpi from '../Pages/Configuration/EditKpi/editKpi';
import CheckConnection from '../Components/NetworkProvider/detectOffline';
import Dashboard from '../Pages/DealTransition/Dashboard/dashboard';
import Revenue from '../Pages/DealTransition/Revenue/revenue';
import DealStatusMaster from '../Pages/DealStatusMaster/dealStatus';
import DealParameterMaster from '../Pages/DealParameterMaster/dealParameterMaster';
import DealRoleMaster from '../Pages/DealRoleMaster/dealRoleMaster';
import DealDetailsView from '../Pages/DealTransition/Dashboard/dealDetailedView/dealDetailedView';
import WorkFlow from '../Pages/DealTransition/WorkFlow/workflow';
import EffortsCalculator from '../Pages/EffortsCalculator/effortsCalculator';
import DeclarePeriod from '../Pages/PerformanceMaster/DeclarePeriod/declarePeriod';
import DecalreSourceRemark from '../Pages/PerformanceMaster/DeclareSourceRemark/decalreSourceRemark';
import TransitionForm from '../Pages/DealTransition/Dashboard/TransitionForm/transitionForm';
import Efforts from '../Pages/DealTransition/Dashboard/Efforts/efforts';
import CostMaster from '../Pages/CostMaster/costMaster';
import EffortUpload from '../Pages/DataUpload/EffortUpload/effortUpload';
import LeaveUpload from '../Pages/DataUpload/LeaveUpload/leaveUpload';
import { MODULE_NAMES } from '../Constants/modules';
import StaffAugStatusMaster from '../Pages/StaffAugStatusMaster/staffAugStatusMaster';
import ResourceRequirement from '../Pages/StaffAugmentation/requestResource';
import CollectionReport from '../Pages/MIS/CollectionReport';
import Staffing from '../Pages/DealTransition/Staffing/staffing';
import UploadConfig from '../Pages/DataUpload/uploadConfig';
import Financials from '../Pages/DealTransition/Dashboard/Financials/financials';
import ResellerReport from '../Pages/MIS/ResellerReport/ResellerReport';
import HealthCheck from '../Pages/MIS/PMOHealthCheck/HealthCheck';
import StaffAugmentationReport from '../Pages/MIS/StaffAugmentationReport/staffAugmentationReport';
import StaffAugmentationRequirement from '../Pages/StaffAugmentation/staffAugmentation';
import ProjectOverview from '../Pages/Delivery/projectOverview/projectOverview';
import FileUpload from '../Pages/DataUpload/FileUpload/fileUpload';
import TechSession from '../Pages/TechSession/NewRequest/techSession';
import Blogs from '../Pages/Blogs/blogs';
import EffortApproval from '../Pages/DealTransition/DealApproval/DealsEffortApproval/effortApproval';
import SignupTechSession from '../Pages/TechSession/Signup/signUpTechSession';
import ReceivedRequest from '../Pages/TechSession/ReceivedRequest/receivedRequest';
import TechSessionCalendarView from '../Pages/TechSession/NewRequest/techSessionCalender';
import NotificationDetail from '../Components/Notifications/notificationfullView';
import DeliveryUtilizationReport from '../Pages/MIS/DeliveryUtilizationReport/DeliveryUtilizationReport';
import ProjectUtilization from '../Pages/MIS/ProjectUtilization/projectUtilization';
import EmployeeUtilizationReport from '../Pages/MIS/EmployeeUtilizationReport/EmployeeUtilizationReport';
import ActivityReport from '../Pages/MIS/ActivityReport/ActivityReport';
import ArchHealthCheck from '../Pages/MIS/PMOHealthCheck/ArchitectHealthCheck/ArchHealthCheck';
import AddProject from '../Pages/Delivery/AddProjects/addProject';
import ProjectDetails from '../Pages/Delivery/ProjectDetails/projectDetails';
import RequestHistoryPage from '../Pages/Delivery/ProjectDetails/RequestHistory/RequestHistoryPage';
import BudgetChangeRequestPage from '../Pages/Delivery/ProjectDetails/BudgetChangeRequest/BudgetChangeRequestPage';
import StaffingRequestPage from '../Pages/Delivery/StaffingRequest/StaffingRequestPage';
import ResourceLoadingPlan from '../Pages/Delivery/ProjectDetails/ResourceLoadingPlan/ResourceLoadingPlan';
import ResourceLoadingApprovalHistory
  from '../Pages/Delivery/ProjectDetails/ResourceLoadingPlan/ResourceLoadingApprovalHistory';
import Timeline from '../Pages/Delivery/ProjectDetails/Timelines/Timeline';
import CsatHistory from '../Pages/Delivery/ProjectDetails/CsatHistory/CsatHistory';
import CsatCustomerDetails from '../Pages/MIS/CsatCustomerDetails/CsatCustomerDetails';
import OfferingWiseReport from '../Pages/MIS/OfferingWiseReport/OfferingWiseReport';
import ProjectCostReportMain from '../Pages/MIS/ProjectCostReport/ProjectCostReportMain';
import ProjectAllocation from '../Pages/MIS/ProjectAllocation/ProjectAllocation';
import CloudProvider from '../Pages/Configuration/CloudProvider/cloudProvider';
import BillingType from '../Pages/Configuration/BillingType/billingType';
import DepartmentList from '../Pages/Configuration/DepartmentList/departmentList';
import EmployeeExperience from '../Pages/Configuration/EmployeeExperience/employeeExperience';
import AllocationStakeholders from '../Pages/Masters/AllocationStakeHolders/allocationStakeholders';


import ImdTable from '../Pages/MIS/IMD/imdTable';
import RevenueRecognition from '../Pages/MIS/RevenueRecognition/RevenueRecognition';
import RevenueMIS from '../Pages/MIS/RevenueMIS/RevenueMis';
import EmployeeMIS from '../Pages/MIS/EmployeeMIS/employeeMis';
import AIToolMIS from '../Pages/MIS/AIToolMIS/AIToolMIS';
import MisMilestone from '../Pages/MIS/MilestoneMIS/MisMilestone';
import RiskRegister from '../Pages/MIS/RiskRegister/RiskRegister';
import MilestoneDetailsMain from '../Pages/Finance/MilestoneDetails/index';
import EmployeeCostDetailsMain from '../Pages/Finance/EmployeeCostDetails/EmployeeCostDetailsMain';
import ChangeRequest from '../Pages/Project/ChangeRequest/changeRequest';
import EdREmployeeEffort from '../Pages/MIS/EDREmployeeEffort/EDREmployeeEffortMain';
import PoMis from '../Pages/MIS/POMIS/PoMisIndex';
import PeopleVsProjectCount from '../Pages/MIS/PeopleVsProjectCount/PeopleVsProjectCount';
import EDRProjectEffortMain from '../Pages/MIS/EDRProjectEffort/EDRProjectEffortMain';
import ProjectEmployeeCostMain from '../Pages/MIS/FinanceReport/ProjectEmployeeCostMain';
// eslint-disable-next-line no-unused-vars
import ProjectWiseExpenseReportMain from '../Pages/MIS/ProjectWiseExpenseReport/ProjectWiseExpenseReportMain';
import MilestoneReportMain from '../Pages/MIS/MilestoneReport/MilestoneReportMain';
import ZohoInvoiceDetails from '../Pages/ZohoInvoiceDetails/zohoInvoiceDetails';
import EDRActivityReportMain from '../Pages/MIS/EDRActivityReport/EDRActivityReportMain';
import AllocationMisMain from '../Pages/MIS/AllocationMis/AllocationMisMain';
import ResourceManagement from '../Pages/Resource/ResourceManagement/ResourceManagement';
import TimeSheetReportMIS from '../Pages/MIS/TimesheetMIS/timesheetMIS';
import TBHEmployeeManagement from '../Pages/TBHEmployeeManagement/TBHEmployeeManagement';
import ResourceAllocation from '../Pages/Resource/ResourceAllocation/ResourceAllocation';
import ShiftAllowance from '../Pages/Resource/ShiftAllowance/ShiftAllowance';
import ShiftAllowanceApprovalHistory from '../Pages/Resource/ShiftAllowance/ShiftAllowanceApprovalHistory';
import ShiftAllowanceMis from '../Pages/MIS/ShiftAllowanceMis/ShiftAllowanceMis';
import BillingReport from '../Pages/MIS/BillingReport/BillingReport';
import BillingReportApprovalHistory from '../Pages/MIS/BillingReport/BillingReportApprovalHistory';
import EmployeeManagement from '../Pages/EmployeeManagement/EmployeeManagement';
import TimeSheetReport from '../Pages/Project/TimeSheetReport/timeSheetReport';
import ChangeHistory from '../Pages/EmployeeManagement/ChangeHisotry';
import ProjectFileUpload from '../Pages/Project/FileUpload/fileUpload';
import ProjectRights from '../Pages/Resource/ProjectRights/ProjectRights';
import ProjectInfoLookup from '../Pages/Delivery/ProjectInfoLookup/ProjectInfoLookup';
import ChangeRequestMIS from '../Pages/MIS/ChangeRequestMIS/ChangeRequest';
import TbhResourceManagement from '../Pages/TbhResourceManagement/TbhResourceManagement';
import StaffingMis from '../Pages/MIS/StaffingMis/StaffingMis';
import GrossMarginReport from '../Pages/MIS/GrossMarginReport/GrossMarginReport';
import ProjectWiseSalaryReport from '../Pages/MIS/ProjectWiseSalaryReport/ProjectWiseSalaryReport';
import AccruedRevenueReportMain from '../Pages/MIS/AccruedRevenueReport/AccruedRevenueReportMain';
import EstimatedVsActualReportMain from '../Pages/MIS/EstimatedVsActualReport/EstimatedVsActualReport';
import RoleRatioReport from '../Pages/MIS/RoleRatioReport/RoleRatioReport';
import RegionList from '../Pages/Configuration/RegionList/RegionList';
import InvoiceType from '../Pages/Configuration/InvoiceType/InvoiceType';
import CountryList from '../Pages/Configuration/CountryList/CountryList';
import DeliveryMethodology from '../Pages/Configuration/DeliveryMethodology/DeliveryMethodology';
import InvoicePaymentStatus from '../Pages/Configuration/InvoicePaymentStatus/invoicePaymentStatus';
import EmployeeVertical from '../Pages/Configuration/EmployeeVertical/employeeVertical';
import InvoiceStatus from '../Pages/Configuration/InvoiceStatus/invoiceStatus';
import AiAccessReq from '../Pages/Resource/AIAccessReq/aiAccessReq';
import AiAccessReqDashBoard from '../Pages/Resource/AiAccessReqDashBoard/aiAccessReqDashBoard';

import IssueCategory from '../Pages/Configuration/IssueCategory/issueCategory';
import IssueStatus from '../Pages/Configuration/IssueStatus/issueStatus';

const PrivateRoute = ({ element, requiredPermissions = [], matchAnyPermission = false }) => {
  const [isAuthenticated, setIsAuthenticated] = useState('loading'); // 'loading', true, false
  const { setUserProfile, userProfile } = useAuth();
  const [isConnectionCheck, setIsConnectionCheck] = useState(true);

  // Using useCallback to ensure a stable reference
  const Wrapper = React.useMemo(() => new AxiosWrapper(), []);
  const location = useLocation();
  const handleConnectionCheck = (online) => {
    setIsConnectionCheck(online);
  };

  // Dev bypass: set `window.__DEV_SHOW_LAYOUT = true` in the browser console
  // to render protected routes without authentication (local debugging only).
  const devBypass = typeof window !== 'undefined' && Boolean(window.__DEV_SHOW_LAYOUT);
  if (devBypass) {
    return (
      <>
        <CheckConnection onCheck={handleConnectionCheck} displaySnackbar={false} />
        {element}
      </>
    );
  }

  const validateToken = async () => {
    if (!isConnectionCheck) {
      return;
    }
    try {
      const token = Wrapper.getAuthToken();
      if (!token) {
        setIsAuthenticated(false);
        return;
      }
      const userProfileInfo = await Wrapper.validateToken();
      if (userProfileInfo.permissions) {
        setUserProfile(userProfileInfo);
        setIsAuthenticated(true);
      } else {
        throw new Error('Invalid token, login again');
      }
    } catch (error) {
      console.error(error); // Log the error or show a user-friendly message
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    validateToken();
  }, [location]);

  if (!isAuthenticated) {
    localStorage.setItem('redirectAfterLogin', window.location.href);
    const isIntentionalLogout = localStorage.getItem('intentionalLogout');
    if (!isIntentionalLogout) {
      // Store the current path before redirecting
      localStorage.setItem('redirectPath', location.pathname);
    } else {
      localStorage.removeItem('intentionalLogout');
    }
    return <Navigate to="/" replace />;
  }

  if (isAuthenticated === 'loading') {
    return <Loader />; // Consider using a spinner or a more descriptive loading indicator
  }

  const checkSinglePermission = (permission) => {
    const rawLogin = String(
      userProfile?.login_type
      || userProfile?.loginType
      || userProfile?.Login_Type
      || userProfile?.user_type
      || '',
    ).trim();
    const loginType = rawLogin.toLowerCase();
    const roleList = Array.isArray(userProfile?.roleDetails)
      ? userProfile.roleDetails
      : (userProfile?.roleDetails ? [userProfile.roleDetails] : []);
    const isSuperAdmin = loginType === 'admin'
      || loginType === 'super admin'
      || roleList.some((role) => {
        const rawRole = String(role?.roleName || role?.role_name || role?.name || '').trim();
        const name = rawRole.toLowerCase();
        const id = Number(role?.role_id ?? role?.roleId ?? role?.id);
        return name === 'super admin' || name === 'admin' || id === 1;
      });

    if (isSuperAdmin) {
      return true;
    }

    const permissions = userProfile?.permissions || {};
    const permissionKeys = Object.keys(permissions);
    const permissionCandidates = [
      permission,
      permission.replace(/-/g, '_'),
      permission.replace(/_/g, '-'),
    ];

    if (
      permissionCandidates.some((candidate) => permissionKeys.includes(candidate))
      || permissionCandidates.some((candidate) => (
        permissionKeys.some((permissionKey) =>
          permissionKey.startsWith(`${candidate}_`)
          || permissionKey.startsWith(`${candidate}:`),
        )
      ))
    ) {
      return true;
    }

    const permissionParts = permission.split('_');
    if (permissionParts.length < 2) return false;

    const action = permissionParts.pop();
    const modules = permissionParts.join('_');

    const allowedActions = permissions[modules]
      || permissions[modules.replace(/-/g, '_')]
      || permissions[modules.replace(/_/g, '-')];

    return Array.isArray(allowedActions) && allowedActions.includes(action);
  };

  const hasRequiredPermissions = matchAnyPermission
    ? requiredPermissions.some(checkSinglePermission)
    : requiredPermissions.every(checkSinglePermission);

  if (isAuthenticated && hasRequiredPermissions) {
    return (
      <>
        <CheckConnection
          onCheck={handleConnectionCheck}
          displaySnackbar={false}
        />
        {element}
      </>
    );
  }

  return <Navigate to="/" replace />;
};

PrivateRoute.propTypes = {
  element: PropTypes.node.isRequired,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  matchAnyPermission: PropTypes.bool,
};

const Routers = () => {
  return (
    <Router>
      <MainContentWrapper>
        <Routes>
          <Route path="/" element={<LogIn />} />
          <Route path="/home" element={<PrivateRoute element={<Home />} />} />
          <Route
            path="/employee-profile"
            element={<PrivateRoute element={<EmployeeProfile />} />}
          />
          <Route
            path="/masters/role"
            element={
              <PrivateRoute
                element={<RoleMaster />}
                requiredPermissions={[MODULE_NAMES.MASTER_DELIVERY_ROLE]}
              />
            }
          />
          <Route
            path="masters/certification-category"
            element={
              <PrivateRoute
                element={<CertificationCategory />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_TRAINING_CERT_CATEGORY,
                ]}
              />
            }
          />
          <Route
            path="/masters/skill"
            element={
              <PrivateRoute
                element={<Skills />}
                requiredPermissions={[MODULE_NAMES.MASTER_TRAINING_SKILL]}
              />
            }
          />
          <Route
            path="/masters/certification"
            element={
              <PrivateRoute
                element={<CertificationMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_TRAINING_CERTIFICATION,
                ]}
              />
            }
          />
          <Route
            path="masters/certification-category"
            element={
              <PrivateRoute
                element={<CertificationCategory />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_TRAINING_CERT_CATEGORY,
                ]}
              />
            }
          />
          <Route
            path="/masters/deal-status"
            element={
              <PrivateRoute
                element={<DealStatusMaster />}
                requiredPermissions={[MODULE_NAMES.MASTER_DEAL_STATUS]}
              />
            }
          />
          <Route
            path="certifications/overview"
            element={
              <PrivateRoute
                element={<CertificationsOverview />}
                requiredPermissions={[MODULE_NAMES.CERTIFICATION_OVERVIEW]}
              />
            }
          />
          <Route
            path="certifications/map"
            element={
              <PrivateRoute
                element={<CertifyMap />}
                requiredPermissions={[MODULE_NAMES.CERTIFICATION_MAP]}
              />
            }
          />
          <Route
            path="/certifications/target"
            element={
              <PrivateRoute
                element={<Targets />}
                requiredPermissions={[MODULE_NAMES.CERTIFICATION_TARGET]}
              />
            }
          />
          <Route
            path="/certifications/targets/set-target"
            element={
              <PrivateRoute
                element={<TargetSetter />}
                requiredPermissions={[
                  MODULE_NAMES.CERTIFICATION_TARGET + '_create',
                ]}
              />
            }
          />
          <Route
            path="/certifications/targets/edit-target"
            element={
              <PrivateRoute
                element={<TargetSetter isEdit={true} />}
                requiredPermissions={[
                  MODULE_NAMES.CERTIFICATION_TARGET + '_update',
                ]}
              />
            }
          />
          <Route
            path="/skills"
            element={
              <PrivateRoute
                element={<SkillMap />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_SKILL]}
              />
            }
          />
          <Route
            path="/skills/map"
            element={
              <PrivateRoute
                element={<MapSkills />}
                requiredPermissions={[
                  MODULE_NAMES.CONFIGURATION_SKILL + '_create',
                ]}
              />
            }
          />
          <Route
            path="/permissions"
            element={
              <PrivateRoute
                element={<Permission />}
                requiredPermissions={[MODULE_NAMES.PERMISSION]}
              />
            }
          />
          <Route
            path="/configuration/manage-kpi"
            element={
              <PrivateRoute
                element={<ManageKpi />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_MANAGE_KPI]}
              />
            }
          />
          <Route
            path="/configuration/manage-kpi/set-kpi"
            element={
              <PrivateRoute
                element={<SetKpi />}
                requiredPermissions={[
                  MODULE_NAMES.CONFIGURATION_MANAGE_KPI + '_create',
                ]}
              />
            }
          />
          <Route
            path="/configuration/manage-kpi/edit-kpi"
            element={
              <PrivateRoute
                element={<EditKpi />}
                requiredPermissions={[
                  MODULE_NAMES.CONFIGURATION_MANAGE_KPI + '_update',
                ]}
              />
            }
          />
          <Route
            path="/configuration/data-upload/effort-upload"
            element={
              <PrivateRoute
                element={<EffortUpload />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_EFFORT_UPLOAD]}
              />
            }
          />
          <Route
            path="/configuration/data-upload/leave-upload"
            element={
              <PrivateRoute
                element={<LeaveUpload />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_LEAVE_UPLOAD]}
              />
            }
          />
          <Route
            path="/configuration/data-upload/file-upload"
            element={
              <PrivateRoute
                element={<FileUpload />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_FILE_UPLOAD]}
              />
            }
          />
          <Route
            path="/configuration/date-config"
            element={
              <PrivateRoute
                element={<UploadConfig />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_DATE_CONFIG]}
              />
            }
          />
          <Route
            path="/deal-transition/dashboard"
            element={
              <PrivateRoute
                element={<Dashboard />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_DASHBOARD]}
              />
            }
          />
          <Route
            path="/deal-transition/revenue"
            element={
              <PrivateRoute
                element={<Revenue />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_REVENUE]}
              />
            }
          />
          <Route
            path="/deal-transition/dashboard/details-view"
            element={
              <PrivateRoute
                element={<DealDetailsView />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_DASHBOARD]}
              />
            }
          />
          <Route
            path="/deal-transition/dashboard/transition-form"
            element={
              <PrivateRoute
                element={<TransitionForm />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_DASHBOARD]}
              />
            }
          />
          <Route
            path="/deal-transition/dashboard/efforts"
            element={
              <PrivateRoute
                element={<Efforts />}
                requiredPermissions={[
                  MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION,
                ]}
              />
            }
          />
          <Route
            path="/deal-transition/dashboard/financials"
            element={
              <PrivateRoute
                element={<Financials />}
                requiredPermissions={[
                  MODULE_NAMES.DEAL_TRANSITION_DETAIL_COMMERCIALS,
                ]}
              />
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute
                element={<Users />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_USER]}
              />
            }
          />
          <Route
            path="/masters/parameters"
            element={
              <PrivateRoute
                element={<DealParameterMaster />}
                requiredPermissions={[MODULE_NAMES.MASTER_DEAL_PARAMETERS]}
              />
            }
          />
          <Route
            path="/masters/efforts"
            element={
              <PrivateRoute
                element={<EffortsCalculator />}
                requiredPermissions={[MODULE_NAMES.MASTER_DEAL_EFFORTS]}
              />
            }
          />
          <Route
            path="/masters/deal-role"
            element={
              <PrivateRoute
                element={<DealRoleMaster />}
                requiredPermissions={[MODULE_NAMES.MASTER_DEAL_ROLE]}
              />
            }
          />
          <Route
            path="/masters/performance/period"
            element={
              <PrivateRoute
                element={<DeclarePeriod />}
                requiredPermissions={[MODULE_NAMES.MASTER_PERFORMANCE_PERIOD]}
              />
            }
          />
          <Route
            path="/masters/performance/source-remarks"
            element={
              <PrivateRoute
                element={<DecalreSourceRemark />}
                requiredPermissions={[MODULE_NAMES.MASTER_REMARKS]}
              />
            }
          />
          <Route
            path="/deal-transition/workflow"
            element={
              <PrivateRoute
                element={<WorkFlow />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_WORKFLOW]}
              />
            }
          />
          <Route
            path="/masters/cost"
            element={
              <PrivateRoute
                element={<CostMaster />}
                requiredPermissions={[MODULE_NAMES.MASTER_COST_MASTER]}
              />
            }
          />
          <Route
            path="mis/collection-report"
            element={
              <PrivateRoute
                element={<CollectionReport />}
                requiredPermissions={[MODULE_NAMES.MIS_COLLECTION_REPORT]}
              />
            }
          />
          <Route
            path="mis/risk-register"
            element={
              <PrivateRoute
                element={<RiskRegister />}
                requiredPermissions={[MODULE_NAMES.MIS_RISK_REGISTER]}
              />
            }
          />
          <Route
            path="mis/change-request"
            element={
              <PrivateRoute
                element={<ChangeRequestMIS />}
                requiredPermissions={[MODULE_NAMES.MIS_CHANGE_REQUEST]}
              />
            }
          />
          <Route
            path="mis/reseller-report"
            element={
              <PrivateRoute
                element={<ResellerReport />}
                requiredPermissions={[MODULE_NAMES.MIS_RESELLER_REPORT]}
              />
            }
          />
          <Route
            path="mis/delivery-utilization-report"
            element={
              <PrivateRoute
                element={<DeliveryUtilizationReport />}
                requiredPermissions={[MODULE_NAMES.MIS_DELIVERY_UTILIZATION_REPORT]}
              />
            }
          />
          <Route
            path="mis/activity-report"
            element={
              <PrivateRoute
                element={<ActivityReport />}
                requiredPermissions={[MODULE_NAMES.MIS_ACTIVITY_REPORT]}
              />
            }
          />
          <Route
            path="mis/utilization-activity-report"
            element={<Navigate to="/mis/activity-report" replace />}
          />
          <Route
            path="mis/health-check"
            element={
              <PrivateRoute
                element={<HealthCheck />}
                requiredPermissions={[MODULE_NAMES.MIS_HEALTH_CHECK]}
              />
            }
          />
          <Route
            path="mis/imd-report"
            element={
              <PrivateRoute
                element={<ImdTable />}
                requiredPermissions={[MODULE_NAMES.MIS_IMD_VIEW]}
              />
            }
          />
          <Route
            path="mis/revenue-recognition"
            element={
              <PrivateRoute
                element={<RevenueRecognition />}
                requiredPermissions={[MODULE_NAMES.MIS_REVENUE_RECOGNITION]}
              />
            }
          />
          <Route
            path="/mis/revenue-mis"
            element={
              <PrivateRoute
                element={<RevenueMIS />}
                requiredPermissions={[MODULE_NAMES.MIS_REVENUE_MIS]}
              />
            }
          />
          <Route
            path="mis/employee-mis"
            element={
              <PrivateRoute
                element={<EmployeeMIS />}
                requiredPermissions={[MODULE_NAMES.MIS_EMPLOYEE_DETAILS]}
              />
            }
          />
          <Route
            path="mis/ai-tool-mis"
            element={
              <PrivateRoute element={<AIToolMIS />} />
            }
          />
          <Route
            path="mis/milestone-mis"
            element={
              <PrivateRoute
                element={<MisMilestone />}
                requiredPermissions={[MODULE_NAMES.MIS_MILESTONE]}
              />
            }
          />
          <Route
            path="finance/milestone-details"
            element={
              <PrivateRoute
                element={<MilestoneDetailsMain />}
                requiredPermissions={[MODULE_NAMES.FINANCE_MILESTONE]}
              />
            }
          />
          <Route
            path="/finance/employee-cost-details"
            element={
              <PrivateRoute
                element={<EmployeeCostDetailsMain />}
                requiredPermissions={[MODULE_NAMES.FINANCE_EMPLOYEE_COST]}
              />
            }
          />
          <Route
            path="/finance/zoho-client-details"
            element={
              <PrivateRoute
                element={<ZohoCustomerDetails />}
                requiredPermissions={[
                  MODULE_NAMES.FINANCE_ZOHO_CUSTOMER_DETAILS,
                ]}
              />
            }
          />
          <Route
            path="/finance/zoho-invoice-details"
            element={
              <PrivateRoute
                element={<ZohoInvoiceDetails />}
                requiredPermissions={[MODULE_NAMES.FINANCE_ZOHO_INVOICE_DETAILS]}
              />
            }
          />
          <Route
            path="/finance/po-details"
            element={
              <PrivateRoute
                element={<PoDetails />}
                requiredPermissions={[MODULE_NAMES.FINANCE_PO_DETAILS]}
              />
            }
          />
          <Route
            path="/finance/client-details"
            element={
              <PrivateRoute
                element={<ClientDetails />}
                requiredPermissions={[MODULE_NAMES.FINANCE_CLIENT_DETAILS]}
              />
            }
          />
          <Route
            path="/configuration/cloud-provider"
            element={<PrivateRoute element={<CloudProvider />} />}
          />
          <Route
            path="/masters/configuration/allocation-stakeholders"
            element={<PrivateRoute element={<AllocationStakeholders />} />}
          />
          <Route
            path="/configuration/allocation-stakeholders"
            element={<PrivateRoute element={<AllocationStakeholders />} />}
          />
          <Route
            path="/configuration/region-list"
            element={<PrivateRoute element={<RegionList />} />}
          />
          <Route
            path="/configuration/invoice-type"
            element={<PrivateRoute element={<InvoiceType />} />}
          />
          <Route
            path="/configuration/country-list"
            element={<PrivateRoute element={<CountryList />} />}
          />
          <Route
            path="/configuration/billing-type"
            element={<PrivateRoute element={<BillingType />} />}
          />
          <Route
            path="/configuration/department-list"
            element={<PrivateRoute element={<DepartmentList />} />}
          />
          <Route
            path="/configuration/employee-experience"
            element={
              <PrivateRoute
                element={<EmployeeExperience />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_EMPLOYEE_EXPERIENCE]}
              />
            }
          />
          <Route
            path="/configuration/delivery-methodology"
            element={
              <PrivateRoute
                element={<DeliveryMethodology />}
                requiredPermissions={[MODULE_NAMES.MASTERS_DELIVERY_METHODOLGY]}
              />
            }
          />
          <Route
            path="/configuration/invoice-payment-status"
            element={
              <PrivateRoute
                element={<InvoicePaymentStatus />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_INVOICE_PAYMENT_STATUS]}
              />
            }
          />
          <Route
            path="/configuration/employee-vertical"
            element={
              <PrivateRoute
                element={<EmployeeVertical />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_EMPLOYEE_VERTICAL]}
              />
            }
          />
          <Route
            path="/configuration/invoice-status"
            element={
              <PrivateRoute
                element={<InvoiceStatus />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_INVOICE_STATUS]}
              />
            }
          />
          <Route
            path="/configuration/issue-category"
            element={
              <PrivateRoute
                element={<IssueCategory />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_ISSUE_CATEGORY]}
              />
            }
          />
          <Route
            path="/configuration/issue-status"
            element={
              <PrivateRoute
                element={<IssueStatus />}
                requiredPermissions={[MODULE_NAMES.CONFIGURATION_ISSUE_STATUS]}
              />
            }
          />
          {/* Backwards-compatible route used in some links/screens */}
          <Route
            path="/finance/employee-cost"
            element={(
              <PrivateRoute
                element={<EmployeeCostDetailsMain />}
                requiredPermissions={[MODULE_NAMES.FINANCE_EMPLOYEE_COST]}
              />
            )}
          />
          <Route
            path="mis/edr-employee-effort"
            element={
              <PrivateRoute
                element={<EdREmployeeEffort />}
                requiredPermissions={[MODULE_NAMES.MIS_EDR_EMPLOYEE_EFFORT]}
              />
            }
          />
          <Route
            path="mis/edr-project-effort"
            element={
              <PrivateRoute
                element={<EDRProjectEffortMain />}
                requiredPermissions={[MODULE_NAMES.MIS_EDR_PROJECT_EFFORT]}
              />
            }
          />
          <Route
            path="mis/project-employee-cost"
            element={
              <PrivateRoute
                element={<ProjectEmployeeCostMain />}
                requiredPermissions={[MODULE_NAMES.MIS_FINANCE_REPORT]}
              />
            }
          />
          <Route
            path="mis/project-wise-expense-report"
            element={
              <PrivateRoute
                element={<ProjectWiseExpenseReportMain />}
                requiredPermissions={[MODULE_NAMES.PROJECT_WISE_EXPENSE_REPORT]}
              />
            }
          />
          <Route
            path="mis/milestone-report"
            element={
              <PrivateRoute
                element={<MilestoneReportMain />}
                requiredPermissions={[MODULE_NAMES.MILESTONE_REPORT]}
              />
            }
          />
          <Route
            path="mis/edr-activity-report"
            element={
              <PrivateRoute
                element={<EDRActivityReportMain />}
                requiredPermissions={[MODULE_NAMES.MIS_EDR_ACTIVITY_REPORT]}
              />
            }
          />
          <Route
            path="mis/allocation-mis"
            element={
              <PrivateRoute
                element={<AllocationMisMain />}
                requiredPermissions={[MODULE_NAMES.MIS_ALLOCATION_MIS]}
              />
            }
          />
          <Route
            path="mis/po-mis"
            element={
              <PrivateRoute
                element={<PoMis />}
                requiredPermissions={[MODULE_NAMES.PO_MIS]}
              />
            }
          />
          <Route
            path="mis/people-vs-project-count"
            element={
              <PrivateRoute
                element={<PeopleVsProjectCount />}
                requiredPermissions={[MODULE_NAMES.PEOPLE_VS_PROJECT_COUNT]}
              />
            }
          />
          <Route
            path="mis/staff-aug-report"
            element={
              <PrivateRoute
                element={<StaffAugmentationReport />}
                requiredPermissions={[MODULE_NAMES.MIS_STAFF_AUG_REPORT]}
              />
            }
          />
          <Route
            path="mis/project-utilization"
            element={
              <PrivateRoute
                element={<ProjectUtilization />}
                requiredPermissions={[MODULE_NAMES.MIS_PROJECT_UTILIZATION]}
              />
            }
          />
          <Route
            path="mis/employee-utilization-report"
            element={
              <PrivateRoute
                element={<EmployeeUtilizationReport />}
                requiredPermissions={[MODULE_NAMES.MIS_EMPLOYEE_UTILIZATION_REPORT]}
              />
            }
          />
          <Route
            path="mis/offering-wise-report"
            element={
              <PrivateRoute
                element={<OfferingWiseReport />}
                requiredPermissions={[MODULE_NAMES.MIS_OFFERING_WISE_REPORT]}
              />
            }
          />
          <Route
            path="mis/project-cost-report"
            element={
              <PrivateRoute
                element={<ProjectCostReportMain />}
                requiredPermissions={[MODULE_NAMES.MIS_PROJECT_COST_REPORT]}
              />
            }
          />
          <Route
            path="mis/staffing-mis"
            element={
              <PrivateRoute
                element={<StaffingMis />}
                requiredPermissions={[MODULE_NAMES.MIS_STAFFING_MIS]}
              />
            }
          />
          <Route
            path="mis/role-ratio-report"
            element={
              <PrivateRoute
                element={<RoleRatioReport />}
                requiredPermissions={[MODULE_NAMES.MIS_ROLE_RATIO_REPORT]}
              />
            }
          />
          <Route
            path="mis/project-allocation"
            element={
              <PrivateRoute
                element={<ProjectAllocation />}
                requiredPermissions={[MODULE_NAMES.MIS_PROJECT_ALLOCATION]}
              />
            }
          />
          <Route
            path="mis/shift-allowance"
            element={
              <PrivateRoute
                element={<ShiftAllowanceMis />}
                requiredPermissions={[MODULE_NAMES.MIS_SHIFT_ALLOWANCE]}
              />
            }
          />
          <Route
            path="mis/billing-report"
            element={
              <PrivateRoute
                element={<BillingReport />}
                requiredPermissions={[MODULE_NAMES.MIS_BILLING_REPORT]}
              />
            }
          />
          <Route
            path="mis/billing-report/approval-history"
            element={
              <PrivateRoute
                element={<BillingReportApprovalHistory />}
                requiredPermissions={[MODULE_NAMES.MIS_BILLING_REPORT_APPROVAL_HISTORY]}
              />
            }
          />
          <Route
            path="mis/activity-report"
            element={
              <PrivateRoute
                element={<ActivityReport />}
                requiredPermissions={[MODULE_NAMES.MIS_ACTIVITY_REPORT]}
              />
            }
          />
          <Route
            path="mis/timesheet-mis"
            element={
              <PrivateRoute
                element={<TimeSheetReportMIS />}
                requiredPermissions={[
                  MODULE_NAMES.MIS_TIME_SHEET_LIST_VIEW,
                  MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_EMPLOYEE_WISE,
                  MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_ACTIVITY_WISE,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="masters/requirement-status"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_REQUIREMENT_STATUS,
                ]}
              />
            }
          />
          <Route
            path="staff-augmentation/requirement-resource"
            element={
              <PrivateRoute
                element={<ResourceRequirement />}
                requiredPermissions={[
                  MODULE_NAMES.STAFF_AUG_PROJECT_RESOURCING,
                ]}
              />
            }
          />
          <Route
            path="masters/client-interview-status"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_CLIENT_INTERVIEW,
                ]}
              />
            }
          />
          <Route
            path="masters/requirement-status"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_REQUIREMENT_STATUS,
                ]}
              />
            }
          />
          <Route
            path="/deal-transition/staffing"
            element={
              <PrivateRoute
                element={<Staffing />}
                requiredPermissions={[MODULE_NAMES.DEAL_TRANSITION_STAFFING]}
              />
            }
          />
          <Route
            path="masters/client-interview-status"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_CLIENT_INTERVIEW,
                ]}
              />
            }
          />
          <Route
            path="masters/lost-dropped-status"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_LOST_DROPPED_STATUS,
                ]}
              />
            }
          />
          <Route
            path="masters/geography"
            element={
              <PrivateRoute
                element={<StaffAugStatusMaster />}
                requiredPermissions={[
                  MODULE_NAMES.MASTER_STAFFAUG_GEOGRAPHY,
                ]}
              />
            }
          />
          <Route
            path="/staff-augmentation/requirement"
            element={
              <PrivateRoute
                element={<StaffAugmentationRequirement />}
                requiredPermissions={[MODULE_NAMES.STAFF_AUG_REQ_STATUS]}
              />
            }
          />
          <Route
            path="/delivery/project-info-lookup"
            element={
              <PrivateRoute
                element={<ProjectInfoLookup />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_PROJECT_INFO_LOOKUP]}
              />
            }
          />
          <Route
            path="/delivery/project-overview"
            element={
              <PrivateRoute
                element={<ProjectOverview />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW]}
              />
            }
          />
          <Route
            path="/delivery/project-details"
            element={
              <PrivateRoute
                element={<ProjectDetails />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW]}
              />
            }
          />
          <Route
            path="/delivery/project-details/request-history"
            element={
              <PrivateRoute
                element={<RequestHistoryPage />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW]}
              />
            }
          />
          <Route
            path="/delivery/project-details/budget-change-request"
            element={
              <PrivateRoute
                element={<BudgetChangeRequestPage />}
                requiredPermissions={[
                  MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_APPROVE,
                  MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_EFFORTS,
                  MODULE_NAMES.PROJECT_BUDGET_CHANGE_REQUEST_COST,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/delivery/project-details/resource-loading-plan"
            element={
              <PrivateRoute
                element={<ResourceLoadingPlan />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_RESOURCE_LOADING_PLAN]}
              />
            }
          />
          <Route
            path="/delivery/project-details/resource-loading-plan/approval-history"
            element={
              <PrivateRoute
                element={<ResourceLoadingApprovalHistory />}
                requiredPermissions={[
                  MODULE_NAMES.DELIVERY_RESOURCE_LOADING_APPROVAL_HISTORY,
                  MODULE_NAMES.DELIVERY_RESOURCE_LOADING_PLAN,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/delivery/add-projects"
            element={
              <PrivateRoute
                element={<AddProject />}
                requiredPermissions={[
                  MODULE_NAMES.DELIVERY_ADD_PROJECTS,
                  MODULE_NAMES.DELIVERY_PROJECT_DETAILS_EDIT,
                  MODULE_NAMES.DELIVERY_PROJECT_MANAGER_DETAILS_EDIT,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/delivery/staffing-request"
            element={
              <PrivateRoute
                element={<StaffingRequestPage />}
                requiredPermissions={[MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST]}
              />
            }
          />
          <Route
            path="/resource/resource-management"
            element={
              <PrivateRoute
                element={<ResourceManagement />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_RESOURCE_MANAGEMENT]}
              />
            }
          />
          <Route
            path="/resource/tbh-employee-management"
            element={
              <PrivateRoute
                element={<TBHEmployeeManagement />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_TBH_EMPLOYEE_MANAGEMENT]}
              />
            }
          />
          <Route
            path="/resource/resource-allocation"
            element={
              <PrivateRoute
                element={<ResourceAllocation />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_RESOURCE_ALLOCATION]}
              />
            }
          />
          <Route
            path="/resource/ai-access-request"
            element={
              <PrivateRoute
                element={<AiAccessReq />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_AI_ACCESS_REQUEST,
                  MODULE_NAMES.RESOURCE_AI_ACCESS_REQUEST_APPROVAL]}
                matchAnyPermission
              />

            }
          />
          <Route
            path="/resource/ai-access-request-dashboard"
            element={
              <PrivateRoute
                element={<AiAccessReqDashBoard />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_AI_ACCESS_REQ_DASHBOARD,
                  MODULE_NAMES.RESOURCE_AI_ACCESS_REQ_DASHBOARD_SUMMARY]}
                matchAnyPermission
              />

            }
          />
          <Route
            path="/tech-session/calendar"
            element={
              <PrivateRoute
                element={<TechSessionCalendarView />}
                requiredPermissions={[MODULE_NAMES.TECH_SESSION_CALENDAR]}
              />
            }
          />
          <Route
            path="/tech-session/new-request"
            element={
              <PrivateRoute
                element={<TechSession />}
                requiredPermissions={[MODULE_NAMES.TECH_SESSION_NEW_REQUEST]}
              />
            }
          />
          <Route
            path="/tech-session/signup"
            element={
              <PrivateRoute
                element={<SignupTechSession />}
              />
            }
          />
          <Route
            path="/tech-session/received-request"
            element={
              <PrivateRoute
                element={<ReceivedRequest />}
                requiredPermissions={[MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST]}
              />
            }
          />
          <Route
            path="/blogs"
            element={
              <PrivateRoute
                element={<Blogs />}
                requiredPermissions={[MODULE_NAMES.ORGANIZATION_BLOGS]}
              />
            }
          />
          <Route
            path="/notifications/all"
            element={
              <PrivateRoute
                element={<NotificationDetail />}
                requiredPermissions={[MODULE_NAMES.NOTIFICATIONS]}
              />
            }
          />
          <Route
            path="/deal-transition/deal-approval/effort-approval"
            element={
              <PrivateRoute
                element={<EffortApproval />}
                requiredPermissions={[
                  MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL,
                ]}
              />
            }
          />
          <Route
            path="/mis/health-check/architecture"
            element={
              <PrivateRoute
                element={<ArchHealthCheck />}
                requiredPermissions={[
                  MODULE_NAMES.MIS_HEALTH_CHECK_ARCHITECTURE,
                ]}
              />
            }
          />
          <Route
            path="/projects/change-request"
            element={
              <PrivateRoute
                element={<ChangeRequest />}
                requiredPermissions={[MODULE_NAMES.PROJECT_CHANGE_REQUEST]}
              />
            }
          />
          <Route
            path="/projects/time-sheet-report"
            element={
              <PrivateRoute
                element={<TimeSheetReport />}
                requiredPermissions={[
                  MODULE_NAMES.PROJECT_TIME_SHEET_REPORT_LIST_VIEW,
                  MODULE_NAMES.PROJECT_TIME_SHEET_REPORT_CALENDAR_VIEW,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/projects/change-request/timeline"
            element={
              <PrivateRoute
                element={<Timeline />}
                requiredPermissions={[MODULE_NAMES.PROJECT_TIMELINE_CHANGE_REQUEST]}
              />
            }
          />
          <Route
            path="/projects/milestone-details"
            element={
              <PrivateRoute
                element={<MilestoneDetailsMain />}
                requiredPermissions={[MODULE_NAMES.FINANCE_MILESTONE]}
              />
            }
          />
          <Route
            path="/projects/csat-history"
            element={
              <PrivateRoute
                element={<CsatHistory />}
                requiredPermissions={[MODULE_NAMES.MIS_CSAT_HISTORY]}
              />
            }
          />
          <Route
            path="/projects/csat-customer-details"
            element={
              <PrivateRoute
                element={<CsatCustomerDetails />}
                requiredPermissions={[MODULE_NAMES.MIS_CSAT_CUSTOMER_DETAILS]}
              />
            }
          />

          <Route
            path="/resource/employee-management"
            element={
              <PrivateRoute
                element={<EmployeeManagement />}
                requiredPermissions={[MODULE_NAMES.EMPLOYEE_MANAGEMENT_HISTORY]}
              />
            }
          />
          <Route
            path="/resource/project-rights"
            element={
              <PrivateRoute
                element={<ProjectRights />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_PROJECT_RIGHTS]}
              />
            }
          />
          <Route
            path="/resource/shift-allowance"
            element={
              <PrivateRoute
                element={<ShiftAllowance />}
                requiredPermissions={[MODULE_NAMES.RESOURCE_SHIFT_ALLOWANCE]}
              />
            }
          />
          <Route
            path="/resource/shift-allowance/approval-history"
            element={
              <PrivateRoute
                element={<ShiftAllowanceApprovalHistory />}
                requiredPermissions={[
                  MODULE_NAMES.RESOURCE_SHIFT_ALLOWANCE_APPROVAL_HISTORY,
                  MODULE_NAMES.RESOURCE_SHIFT_ALLOWANCE,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/resource/manage-employee-history"
            element={
              <PrivateRoute
                element={<ChangeHistory />}
                requiredPermissions={[MODULE_NAMES.MANAGE_EMPLOYEE_HISTORY]}
              />
            }
          />
          <Route
            path="/resource/tbh-resource-management"
            element={
              <PrivateRoute
                element={<TbhResourceManagement />}
                requiredPermissions={[MODULE_NAMES.TBH_RESOURCE_MANAGEMENT]}
              />
            }
          />
          <Route
            path="/project/file-upload"
            element={
              <PrivateRoute
                element={<ProjectFileUpload />}
                requiredPermissions={[
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_REDMINE,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_HOLIDAY,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE_TEST,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_SALARY,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_PROJECT_EXPENSE,
                  MODULE_NAMES.PROJECT_FILE_UPLOAD_JIRA,
                ]}
                matchAnyPermission
              />
            }
          />
          <Route
            path="/mis/gross-margin-report"
            element={
              <PrivateRoute
                element={<GrossMarginReport />}
                requiredPermissions={[MODULE_NAMES.MIS_GROSS_MARGIN_REPORT]}
              />
            }
          />
          <Route
            path="/mis/accrued-revenue-report"
            element={
              <PrivateRoute
                element={<AccruedRevenueReportMain />}
                requiredPermissions={[MODULE_NAMES.MIS_ACCRUED_REVENUE_REPORT]}
              />
            }
          />
          <Route
            path="/mis/estimated-vs-actual"
            element={
              <PrivateRoute
                element={<EstimatedVsActualReportMain />}
                requiredPermissions={[MODULE_NAMES.MIS_ESTIMATED_VS_ACTUAL_REPORT]}
              />
            }
          />
          <Route
            path="/mis/projectwise-salary-report"
            element={
              <PrivateRoute
                element={<ProjectWiseSalaryReport />}
                requiredPermissions={[MODULE_NAMES.PROJECT_WISE_SALARY_REPORT]}
              />
            }
          />
        </Routes>
      </MainContentWrapper>
    </Router>
  );
};

PrivateRoute.propTypes = {
  element: PropTypes.node.isRequired,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
};

PrivateRoute.defaultProps = {
  requiredPermissions: [],
};

export default Routers;
